module.exports = __webpack_public_path__ + "img/eop-law-logo.6fc395e8.png";